import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import Header from "@/components/layout/header";
import ChoiceMappingsTable from "@/components/choice-mappings/choice-mappings-table";
import ChoiceMappingForm from "@/components/choice-mappings/choice-mapping-form";

const ChoiceMappingsPage = () => {
  const [showAddMappingModal, setShowAddMappingModal] = useState(false);
  const queryClient = useQueryClient();

  const handleRefresh = () => {
    queryClient.invalidateQueries({ queryKey: ["/api/choice-mappings"] });
    queryClient.invalidateQueries({ queryKey: ["/api/field-mappings"] });
  };

  return (
    <div className="flex flex-col h-full">
      <Header title="Choice Mapping Management" onRefresh={handleRefresh} />
      
      <main className="flex-1 overflow-y-auto p-6 bg-[#F5F5F5]">
        <ChoiceMappingsTable onAddMapping={() => setShowAddMappingModal(true)} />
      </main>

      {showAddMappingModal && (
        <ChoiceMappingForm
          isOpen={showAddMappingModal}
          onClose={() => setShowAddMappingModal(false)}
          onSuccess={() => setShowAddMappingModal(false)}
        />
      )}
    </div>
  );
};

export default ChoiceMappingsPage;
